import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAlerts = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 21 20"
    {...props}
  >
    <path d="M3.774 13.045a.708.708 0 0 1 1.415 0v4.247a.708.708 0 0 1-1.415 0zm0-7.772a1.75 1.75 0 0 1 1.22-1.668 6.13 6.13 0 0 1 4.348.241l.77.343a6.44 6.44 0 0 0 4.16.367 1.84 1.84 0 0 1 2.28 1.785v3.266a2.306 2.306 0 0 1-2.024 2.289l-.456.056a6.54 6.54 0 0 1-3.7-.628l-.7-.346a4.82 4.82 0 0 0-3.991-.128 1.377 1.377 0 0 1-1.907-1.27z" />
  </svg>
);
export default SvgAlerts;
